/**
 * ID ролей пользователя на бэкенде (api/v2/user.roleId).
 * При изменении на бэке — обновить значения здесь и в environment.
 */
export enum UserRoleId {
  /** Телефон указан, SMS не подтверждён */
  Unconfirmed = 4,
  /** Зарегистрирован без телефона (anonymous) */
  Anonymous = 6,
}

/** Справочник для бэкенда — какие roleId ожидает фронт */
export const USER_ROLE_BACKEND_SPEC = {
  unconfirmed: UserRoleId.Unconfirmed,
  anonymous: UserRoleId.Anonymous,
  confirmed: 'любой другой roleId (не 4 и не 6)',
} as const;
